// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__11YwV","title":"ClientReferral_title__R6pU5","itemText":"ClientReferral_itemText__Tty0P"};